(function () {
  'use strict';

  const CACHE_KEY = 'coolibar_size_guide_v1';
  const DEFAULT_UNIT = 'inches';

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  async function loadData(src) {
    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) return JSON.parse(cached);
    } catch (e) {
      // sessionStorage disabled — fall through to fetch
    }

    const response = await fetch(src);
    if (!response.ok) throw new Error('Size guide fetch failed: ' + response.status);
    const data = await response.json();

    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch (e) {
      // storage full or disabled — ignore
    }

    return data;
  }

  function buildTable(rows) {
    const sizeKeys = Object.keys(rows);
    if (sizeKeys.length === 0) return '';

    const columns = Object.keys(rows[sizeKeys[0]]);

    const header =
      '<tr><th scope="col">Size</th>' +
      columns.map((c) => '<th scope="col">' + escapeHtml(c) + '</th>').join('') +
      '</tr>';

    const body = sizeKeys
      .map((size) => {
        const row = rows[size];
        const cells = columns
          .map((col) => '<td>' + escapeHtml(row[col] == null ? '' : row[col]) + '</td>')
          .join('');
        return '<tr><th scope="row">' + escapeHtml(size) + '</th>' + cells + '</tr>';
      })
      .join('');

    return (
      '<table class="size-chart__table"><thead>' +
      header +
      '</thead><tbody>' +
      body +
      '</tbody></table>'
    );
  }

  function buildBrasTable(sizes) {
    const header = '<tr><th scope="col">Bra Size</th><th scope="col">Coolibar Size</th></tr>';
    const body = Object.entries(sizes)
      .map(
        ([bra, size]) =>
          '<tr><td>' + escapeHtml(bra) + '</td><td>' + escapeHtml(size) + '</td></tr>'
      )
      .join('');
    return (
      '<table class="size-chart__table"><thead>' +
      header +
      '</thead><tbody>' +
      body +
      '</tbody></table>'
    );
  }

  function renderChart(el, data, unit) {
    const code = el.dataset.chartCode;
    const chart = data[code];
    const bodyEl = el.querySelector('[data-size-chart-body]');
    const titleEl = el.querySelector('[data-size-chart-title]');
    const toggleEl = el.querySelector('[data-size-chart-toggle]');

    if (!chart) {
      el.hidden = true;
      console.warn('[size-chart] No chart data for code:', code);
      return;
    }

    if (titleEl) titleEl.textContent = chart.title || '';

    if (chart.sizes) {
      if (toggleEl) toggleEl.hidden = true;
      if (bodyEl) bodyEl.innerHTML = buildBrasTable(chart.sizes);
      return;
    }

    if (toggleEl) toggleEl.hidden = false;
    const rows = chart[unit] || chart.inches;
    if (bodyEl) bodyEl.innerHTML = buildTable(rows);

    if (toggleEl) {
      toggleEl.querySelectorAll('button[data-unit]').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.dataset.unit === unit ? 'true' : 'false');
      });
    }
  }

  function attachToggle(el, data) {
    const toggleEl = el.querySelector('[data-size-chart-toggle]');
    if (!toggleEl) return;

    toggleEl.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-unit]');
      if (!btn) return;
      renderChart(el, data, btn.dataset.unit);
    });
  }

  async function initElement(el) {
    if (el.dataset.initialized === 'true') return;
    el.dataset.initialized = 'true';

    const src = el.dataset.src;
    if (!src) return;

    try {
      const data = await loadData(src);
      renderChart(el, data, DEFAULT_UNIT);
      attachToggle(el, data);
    } catch (err) {
      const bodyEl = el.querySelector('[data-size-chart-body]');
      if (bodyEl) {
        bodyEl.innerHTML = '<p class="size-chart__error">Size chart could not be loaded.</p>';
      }
      console.error('[size-chart]', err);
    }
  }

  function init() {
    document.querySelectorAll('[data-size-chart]').forEach(initElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
